<template>
   <div class="wrapper">
      <HeaderNav title="选择所属类型" v-if="!isMobile"></HeaderNav>
      <div class="container">
          <div class="section">
            <div class="label-name">请选择所属类型</div>
            <div class="list">
              <div class="list-item" :class="{'list-item-active': typeNo == item.setMealCode}" v-for="(item, index) in typeList" :key="index" @click.stop="cTag(item, index)">
                <div class="list-item-name">{{item.setMealName}}</div>
              </div>
            </div>
            <!-- <Tag>
              <span class="tag-item" 
                :class="{'tag-item-active': typeNo == item.setMealCode}"
                v-for="(item, index) in typeList"
                :key="index"
                @click.stop="cTag(item, index)">{{item.setMealName}}</span>
            </Tag> -->
          </div>
          <div class="section" v-if="settingDesc&&settingDesc!==''">
            <h3>说明</h3>
            <p>{{settingDesc}}</p>
          </div>
        </div>
      <div class="footer-bar"></div>
      <div class="footer">
        <div class="submit-btn" @click="submit">下一步</div>
      </div>
   </div>
 </template>
 
 <script>
 import VantUploadImg from '@/components/VantUploadImg.vue';
 import { getPackageList, getSettingPark, getMealInfo, getAnnualFeeInfo,saveAnnualFee } from '@/api/baseinfo';
 export default {
   components: {
     VantUploadImg: VantUploadImg,
   },
   data () {
    return {
      isMobile: false,
      docHt: document.body.offsetHeight > 0 ? document.body.offsetHeight : document.body.clientHeight,
      isQuick: sessionStorage.getItem('isQuick')||0,
      vipShopCode: sessionStorage.getItem('vipShopCode')||null,
      shopCode: null,
      typeNo:null,
      typeList:[],
      settingDesc: '',
      years:1,
      giftTime: 0,
      setMealValidTime: 1, // 默认有效期年
      businessScaleForm:{}
    }
   },
   created() {
    this.shopCode = this.$route.query ? this.$route.query.shopCode : null;
    this.mobileTerminal((data) => {
      this.isMobile = data
    })
    this.getPackageList();
    this.getSettingPark();
   },
   methods: {
      cTag(item){
        this.typeNo = item.setMealCode;
      },
      getPackageList(){
        getPackageList({shopCode:this.vipShopCode}).then(res=>{
          this.typeList = res.data;
        })
      },
      getSettingPark(){
        getSettingPark({shopCode:this.vipShopCode}).then(res=>{
          this.settingDesc = res.data.settingDesc||'';
        })
      },
      getMealInfo() {
        getMealInfo(this.typeNo).then(res => {
          if(res.code === 200) {
            if(!res.data) return false;
            this.getAnnualFee(res.data);
          } else {
            this.Toast('请选择套餐后重试~');
          }
        })
      },
      getAnnualFee(data) {
        let setMealMoney = '';
        let setMealValidTime = '';
        data.setMealMoney = data.setMealMoney > 0 ? (data.setMealMoney/100) : 0;
        data.setMealMoneyMin = data.setMealMoneyMin > 0 ? (data.setMealMoneyMin/100) : 0;
        data.setMealMoneyMax = data.setMealMoneyMax > 0 ? (data.setMealMoneyMax/100) : 0;
        data.setMealGetMoneyMin = data.setMealGetMoneyMin > 0 ? (data.setMealGetMoneyMin/100) : '';
        data.setMealGetMoneyMax = data.setMealGetMoneyMax > 0 ? (data.setMealGetMoneyMax/100) : '';
        data.setMealGetMoneyDayMax = data.setMealGetMoneyDayMax > 0 ? (data.setMealGetMoneyDayMax/100) : '';
        data.setMealAddShopMoneyMin = data.setMealAddShopMoneyMin > 0 ? (data.setMealAddShopMoneyMin/100) : '';
        data.setMealAddShopMoneyMax = data.setMealAddShopMoneyMax > 0 ? (data.setMealAddShopMoneyMax/100) : '';
        this.years = data.setMealValidTime ? data.setMealValidTime : 1;
        this.setMealValidTime = data.setMealValidTime ? data.setMealValidTime : 1;
        setMealValidTime = (366*this.years)+(this.giftTime*30);
        // 是否有年费
        if(data.setMealAnnualFee == 1) {
          if(data.setMealSales == 1) {
            if(data.setMealFixedMoney == 1) {
              // 固定年费
              setMealMoney = this.toRegNum(data.setMealMoney/data.setMealValidTime) || 0;
            } else if(data.setMealFixedMoney == 0) {
              // 市场人员固定年费
              setMealMoney = this.toRegNum(data.setMealMoneyMax/data.setMealValidTime) || this.toRegNum(data.setMealMoneyMin/data.setMealValidTime) || 0;
            }
          } else {
            setMealMoney = this.toRegNum(data.setMealMoney/data.setMealValidTime) || 0;
          }
        }
        
        this.businessScaleForm = {
          isDel: data.isDel,
          isPay: data.isPay,
          isValid: data.isValid,
          serviceFeeAllFee: data.serviceFeeAllFee,
          setMealType: data.setMealType,
          setMealValidTime: setMealValidTime,
          setMealValidTimeAdd: data.setMealValidTimeAdd,
          setMealCode: data.setMealCode,
          setMealMoney,
          setMealShopNumber: data.setMealShopNumberMax ? data.setMealShopNumberMax : data.setMealShopNumberMin || '',
          setMealAddShopMoney: data.setMealAddShopMoneyMax ? data.setMealAddShopMoneyMax : data.setMealAddShopMoneyMin || '',
          setMealUploadVideoSpace: data.setMealUploadVideoSpace,
          setMealMainFee: data.setMealMainFeeMax ? data.setMealMainFeeMax : data.setMealMainFeeMin || '',
          setMealSaleFee: data.setMealSaleFeeMax ? data.setMealSaleFeeMax : data.setMealSaleFeeMin || '',
          setMealAgentFee: data.setMealAgentFeeMax ? data.setMealAgentFeeMax : data.setMealAgentFeeMin || '',
          setMealSupplierFee: data.setMealSupplierFeeMax ? data.setMealSupplierFeeMax : data.setMealSupplierFeeMin || '',
          setMealShopFee: data.setMealShopFeeMax ? data.setMealShopFeeMax : data.setMealShopFeeMin || '',
          setMealGetMoneyFee: data.setMealGetMoneyFeeMax ? data.setMealGetMoneyFeeMax : data.setMealGetMoneyFeeMin || '',
        }
        this.saveRatio();
      },
      submit() {
        if(!this.typeNo) return this.Toast('请选择所属类型~');
        if(this.isQuick==1){
          this.$router.push({
            path: '/merchant-ratio?shopCode=' + this.shopCode+'&setMealCode='+this.typeNo
          })
        } else {
          this.getMealInfo();
          // this.$router.push({
          //   path: '/agreement?shopCode=' + this.shopCode
          // })
        }
      },
      saveRatio(){
        let params = {};
        let setMealMoney = JSON.parse(JSON.stringify(this.businessScaleForm.setMealMoney));
        let setMealAddShopMoney = JSON.parse(JSON.stringify(this.businessScaleForm.setMealAddShopMoney));
        params = JSON.parse(JSON.stringify(this.businessScaleForm));
        params.shopMallCode = this.shopCode;
        params.setMealCode = this.typeNo;
        params.setMealMoney = setMealMoney*100;
        params.setMealAddShopMoney = setMealAddShopMoney*100;
        params.buyTime = Number(this.years);
        saveAnnualFee(params).then(res => {
          if(res.code === 200) {
            this.$router.push({
              path: '/agreement?shopCode=' + this.shopCode
            })
            // if(params.setMealMoney > 0) {
            //   this.$router.push({
            //     path: '/market-ratio?shopCode=' + this.shopCode
            //   })
            // }
          } else {
            this.Toast('请完善信息后重试~');
          }
        })
      }
   }
 }
 </script>
 
<style lang="scss" scoped>
.container{
  padding: 10px 20px;
  box-sizing: border-box;
}
.section{
  .label-name{
    line-height: 20px;
    font-size: 14px;
    color: #666;
    margin-bottom: 8px;
  }
  h3{
    line-height: 26px;
    font-size: 18px;
    color: #222;
    font-weight: bold;
    margin-top: 12px;
  }
  p{
    line-height: 24px;
    font-size: 16px;
    color: #222;
    margin-top: 10px;
  }
}
.list{
  &-item{
    width: 335px;
    height: 140px;
    background: #FFFFFF;
    border-radius: 10px;
    border: 1px solid #EEEEEE;
    font-size: 18px;
    color: #222;
    margin-bottom: 10px;
    padding: 20px;
    box-sizing: border-box;
    cursor: pointer;
    &-name{
      width: 100%;
      height: 100%;
      display: flex;
      align-items: center;
      justify-content: center;
      overflow: hidden;
    }
    &-active{
      background: #67B4C4;
      border: 0;
      color: #fff;
    }
  }
}
@media screen and (max-width:750px){
  
}
@media screen and (min-width:750px){

}
</style>


// WEBPACK FOOTER //
// src/views/lease-type.vue